// extracted by mini-css-extract-plugin
export default {"container":"bj-z","blurb":"cj-z","links":"dj-z"};